/**
 * Cuenta las columnas del encabezado de la tabla que contiene una fila, sumando los colSpan.
 * @param {HTMLTableRowElement|null} row Fila dentro de la tabla.
 * @returns {number|null} Cantidad de columnas, o `null` si la tabla no tiene encabezado.
 */
export const countHeaderColumns = (row) => {
  const headerRow = row?.closest('table')?.querySelector('thead tr');
  if (!headerRow) return null;
  const total = Array.from(headerRow.cells).reduce((sum, cell) => sum + (cell.colSpan || 1), 0);
  return total || null;
};
